import(/* webpackMode: "eager" */ "/opt/buildhome/repo/landing/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/landing/src/app/components/Header.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/landing/src/app/desktop/page.module.css");
